import Localization from 'lib/localization';

export default {
    lxHomeTitle() {
        return Localization.get('badoo_safety_center@breadcrumbs.home.title');
    },
    lxA11yLabel() {
        return Localization.get('badoo_safety_center@breadcrumbs.a11y.label');
    },
};
